import firebase, {db, auth, fc} from './connection'
import store from '../store.js'
import router from '../router.js'
import Helpers from '@/services/helpers'

function redirectorSign() {
    if (store.getters.user.firstTime === true) {
        router.push('/welcome');
        return;
    }

    if (router.currentRoute.meta.isProcessToSign) {
        router.push('/home');
        
        if (store.getters.user.role.denied == undefined) {
            store.dispatch('setSnack', {kind:'success', text:'Welcome ' + store.getters.user.name + '!'});
        } else {
            store.dispatch('setSnack', {kind:'error', text:'Access denied'});
        }
    }
}

function getUser(uid) {
    let ref = db.collection('users').doc(uid);

    ref.get()
        .then(doc => {
                if (doc.exists) {
                    let user = doc.data();
                    user.uid = doc.id;
                    store.dispatch('setUser', user);
                    redirectorSign();
                }
        });
}

export default {
    setOnAuthState() {
        auth.onAuthStateChanged(user => {
            if (user) {
                if (router.app._route.name != 'legalprivacy' && router.app._route.name != 'legalterms') {
                    getUser(user.uid);
                }
            } else {
                if (router.app._route.name == 'login' || router.app._route.name == 'home') {
                    router.push('/login');
                    return;
                }
                if (router.app._route.name == 'signup') {
                    router.push('/signup');
                    return;
                }
                if (router.app._route.meta && router.app._route.meta.isPublic == undefined) { 
                    router.push('/login');
                    return;
                }
            }
        });
    },

    isLoggedIn() {
		return auth.currentUser;
    },

    reInitUser(uid) {
        getUser(uid);
    },
    
    signin(payload) {
        return auth.signInWithEmailAndPassword(payload.email, payload.pwd)
				.then( response => {
                    getUser(response.user.uid);
					return true;
				})
				.catch(error => {
					return error;
				});
    },

    signup(payload, password) {
        return auth.createUserWithEmailAndPassword(payload.email, password)
                    .then(reg => {
                        let createProfile = fc.httpsCallable('createProfile');
                        let obj = payload;
                        obj.uid = reg.user.uid;
                        return createProfile(obj)
                                    .then(response => {
                                        if (response.data === true) {
                                            getUser(reg.user.uid);
                                            return true;
                                        } else {
                                            return response;
                                        }
                                    })
                                    .catch(error => {
                                        return error;
                                    });
                    })
                    .catch(error => {
                        return error;
                    });
    },

    signout() {
        return auth.signOut()
				.then( () => { 
                    return true;
				})
				.catch(error => {
					console.log(error);
				});
    },

    removeFirstTime(payload) {
        let ref1 = db.collection('users').doc(payload.uid);
        let batch = db.batch();

        batch.update(ref1, { firstTime: false });

        payload.companies.forEach(dt => {
            let refTempo = db.collection('users').doc(payload.uid).collection('companies').doc();
            batch.set(refTempo, dt);
        });

        payload.categories.forEach(dt => {
            let refTempo = db.collection('users').doc(payload.uid).collection('categories').doc();
            batch.set(refTempo, dt);
        });

        return batch.commit()
                    .then( () => {
                        return true;
                    })
                    .catch(error => {
                        return error;
                    });
    },

    getRootCompanies() {
        let ref = db.collection('companies');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    recoverPassword(email) {
		return auth.sendPasswordResetEmail(email)
				.then( () => {
					return true;
				})
				.catch(error => {
					return error;
				});
    }
}